/*
* Copyright(c) 2018. Synergy Systems & Solutions. @link : http://s3india.com 
*
* @module : Questions
* @file : Questions.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of Questions
*
* Created on : 10-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 24-Oct-2019
*/
import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import $ from 'jquery';
import QuestionService from '../../services/QuestionService/QuestionService';
import TopicService from '../../services/TopicService/TopicService';
import Translation from '../../language/Translation';


class Questions extends React.Component
{
	constructor(props)
	{
		super(props);
		this.translation = new Translation();
		this.state = {
			questions:[],
			progressClass:'progress-bar s1-Width',
			translation:{
				'questions_v1':this.translation.getText('questions_v1'),
				'questions_v2':this.translation.getText('questions_v2'),
				'questions_v3':this.translation.getText('questions_v3'),
				'questions_v4':this.translation.getText('questions_v4')
				
			}

		};

		this.questionService = new QuestionService();
		this.topicService = new TopicService();
		this.selectAnswer= this.selectAnswer.bind(this);
		this.sendAnswer= this.sendAnswer.bind(this);
		this.getPrevQues = this.getPrevQues.bind(this);
		this.prevButton = this.prevButton.bind(this);
		this.submitButton = this.submitButton.bind(this);
	}
	selectAnswer(e)
	{
		//console.log(e.target.id);
		$('.list-item').removeClass('active');
		$('input[name="selected_answer"]').val();
		//selected_answer.value = '';
		//selected_answer.value = e.target.id;
		$('input[name="selected_answer"]').val(e.target.id);
		$('#'+e.target.id).addClass('active');
		
	}
	sendAnswer()
	{
		this.setState({questions:[]});
		let question_id = this.state.questions.question.id;
		//let selected_answer = document.getElementById('selected_answer');
		let answer_id = $('.active').attr('id');
		if(answer_id!=='' && typeof answer_id !=='undefined')
		{
		//console.log(answer_id);
		this.questionService.sendAnswer(question_id,answer_id).then(response=>{
			//console.log(response);
			this.setState({questions:response});
		});
	}
	else
	{
		this.setState({questions:this.state.questions});
		$('.btn-primary').addClass('shake');
		setTimeout(function()
		{
			$('.btn-primary').removeClass('shake');
		},900);

	}
	}
	getPrevQues()
	{
		this.setState({questions:[]});
		this.questionService.getPrevQuestions(this.state.questions.question.id).then(response=>{
			this.setState({questions:response});
		});
		console.log(this.state);
	}
	submitButton()
	{
		let questions = this.state.questions;
		let sendAnswer = this.sendAnswer;
		if(questions.status==='1')
		{
			if(questions.question_number==='5' || questions.question_number===5)
			{
				return (
					<React.Fragment>
						<Link to="#" className="btn btn-primary" onClick={sendAnswer}>{this.state.translation.questions_v4}</Link>
	          		</React.Fragment>
				)
			}
			else
			{
				return (
					<React.Fragment>
						<Link to="#" className="btn btn-primary" onClick={sendAnswer}>{this.state.translation.questions_v2}</Link>
					</React.Fragment>
				)
			}
		}
		else
		{
			return (
				<React.Fragment>
					<Link to="#" className="btn btn-primary" onClick={sendAnswer}>{this.state.translation.questions_v2}</Link>
				</React.Fragment>
			)
		}
	}
	componentDidMount()
	{
		const id = this.props.match.params.topic_id;
		////console.log(id);
		////console.log(sessionStorage.getItem('session_id'));
		this.topicService.addTopic(id).then(response=>{
			this.setState({questions:response});
			if(response.status==='1')
			{
				this.setState({progressClass:'progress-bar.s'+response.question_number+'-Width'});
			}
			//console.log(response);
		});
	}

	prevButton()
	{
		let questions = this.state.questions;
		if(questions.status==='1')
		{
			if(questions.question_number==='1' || questions.question_number===1)
			{
				return (
					<span></span>
				)
			}
			else
			{
				return (
					<Link to="#" className="btn btn-link" onClick={this.getPrevQues}>{this.state.translation.questions_v3}</Link>
				)
			}

		}
	}

	renderQuestion()
	{
		let questions = this.state.questions;
		let selectAnswer = this.selectAnswer;
		if(questions.status==='1')
		{
			return (
				<React.Fragment>
				<div className="default-heading fontSize">
				 <h2>{questions.question.name}</h2>
				</div>
				<ul className="listing-details">
				 <li><Link to="#" className="list-item" onClick={selectAnswer} id={questions.answer[0].id}>{questions.answer[0].name}</Link></li>
				 <li><Link to="#" className="list-item" onClick={selectAnswer} id={questions.answer[1].id}>{questions.answer[1].name}</Link></li>
				 <li><Link to="#" className="list-item" onClick={selectAnswer} id={questions.answer[2].id}>{questions.answer[2].name}</Link></li>
				 <li><Link to="#" className="list-item" onClick={selectAnswer} id={questions.answer[3].id}>{questions.answer[3].name}</Link></li>
				</ul>
				<input type="hidden" defaultValue="" name="selected_answer" id="selected_answer"/>
			    <div className="text-center buttons-area">
			     {this.prevButton()}
			     {this.submitButton()}
			    </div>
				</React.Fragment>
			);
        
		}
		else if(questions.status==='2')
		{
			return <Redirect to='/result' />
		}
	}

	renderQuestionNumber()
	{
		let questions = this.state.questions;
		if(questions.status==='1')
		{
			return (
				<React.Fragment>
				<div className="col-12 col-sm-8 col-md-6 col-lg-6">
				<div className="q-area"><Link to="#">Frage {questions.question_number} von 5</Link></div>
				</div>
				<div className="col-12 col-sm-4 col-md-6 col-lg-6">
				<div className="agre-area">
				<Link to="#">
				<i className={`icon icon ques-topic-icon ${questions.topic.icon}`}></i> {questions.topic.name}</Link></div>
        </div>
          		</React.Fragment>
			)
		}
	}
	renderQuestionClass()
	{
		let questions = this.state.questions;
		if(questions.status==='1')
		{
			var progressClass = "progress-bar s"+questions.question_number+"-Width";
			return (
				<React.Fragment>
				<div className={progressClass}></div>
          		</React.Fragment>
			)
		}
	}

	render()
	{
		return (
			<React.Fragment>
				<div className="content-box-area list-area">
      {this.renderQuestionClass()}
      <div className="top-area">
      <div className="row align-content-between align-items-center">
          {this.renderQuestionNumber()}
      </div>
      </div>
       {this.renderQuestion()}
      </div>
			</React.Fragment>
      );
	}
}

export default Questions;